module.exports = __webpack_public_path__ + "static/media/campuscarry.69cc2540.jpg";